import { useEffect, useCallback } from 'react';
import '../redesign.css';
import { RedesignHeader } from './redesign/RedesignHeader';
import { RedesignHero } from './redesign/RedesignHero';
import { TrustStrip } from './redesign/TrustStrip';
import { ServicesPillars } from './redesign/ServicesPillars';
import { CasesBand } from './redesign/CasesBand';
import { ProcessTimeline } from './redesign/ProcessTimeline';
import { WhyPniel } from './redesign/WhyPniel';
import { TestimonialsBand } from './redesign/TestimonialsBand';
import { InsightsTeaser } from './redesign/InsightsTeaser';
import { ContactBand } from './redesign/ContactBand';
import { CtaBand } from './redesign/CtaBand';
import { RedesignFooter } from './redesign/RedesignFooter';

const useRemoveEmergentBadge = () => {
  const removeBadge = useCallback(() => {
    const selectors = [
      '[class*="emergent"]',
      '[id*="emergent"]',
      'iframe[src*="emergent"]',
      'div[style*="position: fixed"][style*="bottom"][style*="right"]',
      'div[style*="z-index: 9999"]'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (el?.textContent?.toLowerCase().includes('emergent')) {
          el.style.display = 'none';
        }
      });
    });

    setTimeout(removeBadge, 2000);
  }, []);

  useEffect(() => {
    removeBadge();
  }, [removeBadge]);
};

const HomePage = () => {
  useRemoveEmergentBadge();

  return (
    <div className="redesign">
      <RedesignHeader />
      <main>
        <RedesignHero />
        <TrustStrip />
        <CasesBand />
        <TestimonialsBand />
        <ServicesPillars />
        <WhyPniel />
        <ProcessTimeline />
        <InsightsTeaser />
        <ContactBand />
        <CtaBand />
      </main>
      <RedesignFooter />
    </div>
  );
};

export default HomePage;
